<ul class="navbar-nav ms-auto">
  <app-webshop-menu-item *ngFor="let menuItem of ctxMain.ShopModuleMenu.MenuItems" [menuItem]="menuItem"></app-webshop-menu-item>
</ul>
